import { Component, Input } from '@angular/core';

@Component({
  selector: 'nrwl-report-view-table',
  templateUrl: './report.view.table.component.html',
  styleUrls: ['./report.view.table.component.scss']
})
export class ReportViewTableComponent {
  @Input() displayedColumns: string[];
  @Input() dataSource: string[];
}
